<a
  analyticsEvents
  [analyticsEventClick]="analyticsEventName"
  [analyticsEventData]="analyticsEventData"
  [attr.title]="link.title"
  [attr.href]="pieceSrc$ | async"
  [attr.class]="styleClass"
  [attr.data-link-type]="link.type"
  [attr.data-category-id]="link.categoryId"
  [attr.data-product-id]="link.productId"
  [attr.data-section]="link.section"
  [attr.data-page]="link.slug"
  [attr.data-analytics-action]="displayAnalyticsAction"
  [target]="newWindow ? '_blank' : undefined"
  data-e2e="render-link"
  (click)="renderLinkClicked()">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
